var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from "react-i18next";
import { theme, Dialog } from "@sequentech/ui-essentials";
import { WizardStyles } from "@/components/styles/WizardStyles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Accordion, AccordionSummary, CircularProgress } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNotify } from "react-admin";
import { Logs } from "@/components/Logs";
import { AdminDateTime } from "@/components/AdminDateTime";
import { ETaskExecutionStatus } from "@sequentech/ui-core";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_TASK_BY_ID } from "@/queries/GetTaskById";
import { GET_DOCUMENT_PASSWORD } from "@/queries/DocumentPassword";
import { CancelButton } from "../Tally/styles";
import { useTasksPermissions } from "./useTasksPermissions";
import { DownloadDocument } from "../User/DownloadDocument";
import { DownloaButton } from "@/components/styles/WidgetStyle";
import { ETasksExecution } from "@/types/tasksExecution";
import { IPermissions } from "@/types/keycloak";
import { VoterInformationLetterDocumentAccess } from "./VoterInformationLetterDocumentAccess";
export var statusColor = function (status) {
    if (status === ETaskExecutionStatus.STARTED) {
        return theme.palette.warning.light;
    }
    else if (status === ETaskExecutionStatus.IN_PROGRESS) {
        return theme.palette.info.main;
    }
    else if (status === ETaskExecutionStatus.SUCCESS) {
        return theme.palette.brandSuccess;
    }
    else if (status === ETaskExecutionStatus.CANCELLED) {
        return theme.palette.errorColor;
    }
    else {
        return theme.palette.errorColor;
    }
};
export var ViewTask = function (_a) {
    var _b, _c;
    var currTaskId = _a.currTaskId, goBack = _a.goBack, electionEventRecord = _a.electionEventRecord, _d = _a.isModal, isModal = _d === void 0 ? false : _d;
    var t = useTranslation().t;
    var notify = useNotify();
    var _e = useState(true), progressExpanded = _e[0], setProgressExpanded = _e[1];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _f = useState(undefined), exportDocumentId = _f[0], setExportDocumentId = _f[1];
    var _g = useState(false), downloading = _g[0], setDownloading = _g[1];
    var _h = useState(), pdfPassword = _h[0], setPdfPassword = _h[1];
    var _j = useTasksPermissions(), showTasksBackButton = _j.showTasksBackButton, canReadDocumentPassword = _j.canReadDocumentPassword;
    var _k = useLazyQuery(GET_DOCUMENT_PASSWORD, {
        fetchPolicy: "no-cache",
        context: {
            headers: {
                "x-hasura-role": IPermissions.DOCUMENT_PASSWORD_READ,
            },
        },
    }), getDocumentPassword = _k[0], passwordLoading = _k[1].loading;
    useEffect(function () {
        setPdfPassword(undefined);
        setExportDocumentId(undefined);
        setDownloading(false);
    }, [currTaskId]);
    var taskData = useQuery(GET_TASK_BY_ID, {
        variables: { task_id: currTaskId },
        skip: !currTaskId,
        pollInterval: globalSettings.QUERY_FAST_POLL_INTERVAL_MS,
    }).data;
    var task = taskData === null || taskData === void 0 ? void 0 : taskData.sequent_backend_tasks_execution[0];
    if (!task) {
        return _jsx(CircularProgress, {});
    }
    var isVoterInformationLetter = task.type === ETasksExecution.VOTER_INFORMATION_LETTER;
    var voterInformationLetterDocumentId = (_b = task.annotations) === null || _b === void 0 ? void 0 : _b.document_id;
    var canAccessVoterInformationLetterDocument = isVoterInformationLetter &&
        canReadDocumentPassword &&
        task.execution_status === ETaskExecutionStatus.SUCCESS &&
        Boolean(task.election_event_id) &&
        Boolean(voterInformationLetterDocumentId);
    var canDownloadDocument = Boolean(task.election_event_id) &&
        Boolean(voterInformationLetterDocumentId) &&
        (!isVoterInformationLetter || canAccessVoterInformationLetterDocument);
    var revealDocumentPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, password, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getDocumentPassword({
                            variables: { documentId: String(voterInformationLetterDocumentId) },
                        })];
                case 1:
                    data = (_c.sent()).data;
                    password = (_b = data === null || data === void 0 ? void 0 : data.get_document_password) === null || _b === void 0 ? void 0 : _b.password;
                    if (!password) {
                        throw new Error("PDF password was not returned");
                    }
                    setPdfPassword(password);
                    return [2 /*return*/, true];
                case 2:
                    _a = _c.sent();
                    notify(t("tasksScreen.documentAccess.passwordError"), { type: "error" });
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var downloadDocument = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!canDownloadDocument || !voterInformationLetterDocumentId) {
                        return [2 /*return*/];
                    }
                    _a = isVoterInformationLetter && !pdfPassword;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, revealDocumentPassword()];
                case 1:
                    _a = !(_b.sent());
                    _b.label = 2;
                case 2:
                    if (_a) {
                        return [2 /*return*/];
                    }
                    setDownloading(true);
                    setExportDocumentId(String(voterInformationLetterDocumentId));
                    return [2 /*return*/];
            }
        });
    }); };
    var Content = (_jsxs(_Fragment, { children: [_jsxs(Accordion, { sx: { width: "100%" }, expanded: progressExpanded, onChange: function () { return setProgressExpanded(!progressExpanded); }, children: [_jsxs(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), children: [_jsx(WizardStyles.AccordionTitle, { children: t("tasksScreen.taskInformation") }), _jsx(WizardStyles.CeremonyStatus, { sx: {
                                    backgroundColor: statusColor(task === null || task === void 0 ? void 0 : task.execution_status),
                                    color: theme.palette.background.default,
                                }, label: String(t("tasksScreen.status", {
                                    status: task === null || task === void 0 ? void 0 : task.execution_status,
                                })) })] }), _jsx(WizardStyles.AccordionDetails, { children: _jsx(TableContainer, { component: Paper, children: _jsx(Table, { "aria-label": "task details table", children: _jsxs(TableBody, { children: [_jsxs(TableRow, { children: [_jsx(TableCell, { sx: { fontWeight: "500", width: "40%" }, children: t("tasksScreen.column.type") }), _jsx(TableCell, { children: (task === null || task === void 0 ? void 0 : task.type) && t("tasksScreen.tasksExecution.".concat(task.type)) })] }), _jsxs(TableRow, { children: [_jsx(TableCell, { align: "left", sx: { fontWeight: "500" }, children: t("tasksScreen.column.executed_by_user") }), _jsx(TableCell, { align: "left", children: task === null || task === void 0 ? void 0 : task.executed_by_user })] }), _jsxs(TableRow, { children: [_jsx(TableCell, { align: "left", sx: { fontWeight: "500" }, children: t("tasksScreen.column.start_at") }), _jsx(TableCell, { align: "left", children: _jsx(AdminDateTime, { value: task === null || task === void 0 ? void 0 : task.start_at, event: electionEventRecord !== null && electionEventRecord !== void 0 ? electionEventRecord : task === null || task === void 0 ? void 0 : task.election_event_id, seconds: true }) })] }), _jsxs(TableRow, { children: [_jsx(TableCell, { align: "left", sx: { fontWeight: "500" }, children: t("tasksScreen.column.end_at") }), _jsx(TableCell, { align: "left", children: _jsx(AdminDateTime, { value: task === null || task === void 0 ? void 0 : task.end_at, event: electionEventRecord !== null && electionEventRecord !== void 0 ? electionEventRecord : task === null || task === void 0 ? void 0 : task.election_event_id, seconds: true }) })] })] }) }) }) })] }), canAccessVoterInformationLetterDocument ? (_jsx(VoterInformationLetterDocumentAccess, { taskId: String(task.id), pdfPassword: pdfPassword, loading: passwordLoading, onReveal: function () { return void revealDocumentPassword(); } })) : null, _jsx(Logs, { logs: task === null || task === void 0 ? void 0 : task.logs, event: electionEventRecord !== null && electionEventRecord !== void 0 ? electionEventRecord : task === null || task === void 0 ? void 0 : task.election_event_id })] }));
    var downloadAction = canDownloadDocument ? (_jsx(DownloaButton, { onClick: function () { return void downloadDocument(); }, disabled: downloading ||
            task.execution_status !== ETaskExecutionStatus.SUCCESS ||
            (isVoterInformationLetter && passwordLoading), label: String(t("tasksScreen.widget.downloadDocument")), sx: isModal ? undefined : { marginLeft: "auto" }, children: _jsx(DownloadIcon, {}) })) : null;
    var downloadTrigger = exportDocumentId ? (_jsx(DownloadDocument, { documentId: exportDocumentId, showReportPasswordDialog: task.type === ETasksExecution.GENERATE_REPORT, electionEventId: (_c = task.election_event_id) !== null && _c !== void 0 ? _c : "", fileName: null, onDownload: function () {
            setDownloading(false);
            setExportDocumentId(undefined);
        } })) : null;
    if (isModal) {
        return (_jsx(Dialog, { open: true, variant: "info", handleClose: goBack, title: String(t("tasksScreen.taskInformation")), ok: String(t("tasksScreen.ok")), fullWidth: true, maxWidth: "md", middleActions: downloadAction ? [downloadAction] : undefined, children: _jsxs(_Fragment, { children: [Content, downloadTrigger] }) }));
    }
    return (_jsxs(WizardStyles.WizardContainer, { children: [_jsx(WizardStyles.ContentWrapper, { children: _jsx(WizardStyles.ContentBox, { children: Content }) }), _jsxs(WizardStyles.FooterContainer, { children: [_jsxs(WizardStyles.StyledFooter, { children: [showTasksBackButton ? (_jsxs(CancelButton, { className: "list-actions", onClick: goBack, children: [_jsx(ArrowBackIosIcon, {}), t("common.label.back")] })) : null, downloadAction] }), downloadTrigger] })] }));
};
